import SignUp from '../components/pages/sign_up/SignUp'

export default {
    SignUp,
}